import { cn } from '@/common/utils/cn'
import { GripVerticalIcon } from 'lucide-react'
import { ButtonHTMLAttributes, forwardRef } from 'react'

const DragHandle = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        'cursor-grab active:cursor-grabbing text-white-800 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <GripVerticalIcon size={20} />
    </button>
  ),
)

DragHandle.displayName = 'DragHandle'

export default DragHandle
